import { render, staticRenderFns } from "./Number.vue?vue&type=template&id=469eac5a&"
import script from "./Number.vue?vue&type=script&lang=js&"
export * from "./Number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('469eac5a')) {
      api.createRecord('469eac5a', component.options)
    } else {
      api.reload('469eac5a', component.options)
    }
    module.hot.accept("./Number.vue?vue&type=template&id=469eac5a&", function () {
      api.rerender('469eac5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue-number-animation/Number.vue"
export default component.exports